/**
 * Planning schedule-entry helpers — the single source shared by the absence-
 * coverage core (`scheduleAbsences.ts`) and the planning backend
 * (`bundle-schedule/src/shared-utils.js`, which re-exports these). Kept here so
 * the date formatting + entry building the overlap-split relies on lives once.
 */

/**
 * Date → 'YYYY-MM-DD' in **UTC**.
 *
 * NB: distinct from `toISODate`, which formats in the local timezone. Planning
 * uses the UTC slice for stable date-only values, so do not swap one for the
 * other — they differ by a day in non-UTC environments.
 */
export const getDateString = (date: Date): string => date.toISOString().substring(0, 10);

/** Percentages may arrive as number or string; coerce, falling back when absent/NaN. */
export const normalizePercentage = (
  value: number | string | null | undefined,
  fallback: number,
): number => {
  if (value == null) return fallback;
  const num = Number(value);
  return Number.isNaN(num) ? fallback : num;
};

/** Builds a replacement schedule entry, carrying over every field but overwriting the id. */
export const createNewScheduleEntry = <T extends Record<string, unknown>>(
  sourceEntry: T,
  generateMockId: () => string,
  start: Date,
  end: Date,
  userId: string,
  percentage?: number,
) => ({
  ...sourceEntry,
  id: generateMockId(),
  start: getDateString(start),
  end: getDateString(end),
  status: 'ai_proposed',
  user: userId,
  ...(percentage !== undefined && { percentage }),
});
